import React from 'react';
import { Building2, LayoutDashboard, Wallet, CalendarDays } from 'lucide-react';

export default function TabBar({ tab, setTab, badges }) {
  const tabs = [
    { key: 'dashboard', label: 'DASHBOARD', Icon: LayoutDashboard, badgeColor: 'var(--accent)' },
    { key: 'office',    label: 'WORKSPACE', Icon: Building2,       badgeColor: 'var(--green)' },
    { key: 'planner',   label: 'PLANNER',   Icon: CalendarDays,    badgeColor: 'var(--red)' },
    { key: 'revenue',   label: 'REVENUE',   Icon: Wallet,          badgeColor: 'var(--gold)' },
  ];

  return (
    <nav className="tabbar" role="tablist" aria-label="Main tabs">
      {tabs.map(t => {
        const badgeCount = badges[t.key] || 0;
        return (
          <button
            key={t.key}
            role="tab"
            aria-selected={tab === t.key}
            aria-controls={`panel-${t.key}`}
            aria-label={badgeCount > 0 ? `${t.label} (${badgeCount}개)` : t.label}
            className={`tab-btn ${tab === t.key ? 'active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            <t.Icon size={16} strokeWidth={tab === t.key ? 2 : 1.5} aria-hidden="true" />
            <span className="tab-btn-label">{t.label}</span>
            {badgeCount > 0 && (
              <span
                className="tab-badge"
                style={{ background: `${t.badgeColor}20`, color: t.badgeColor }}
                aria-hidden="true"
              >
                {badgeCount}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
